import Tooltip from './TooltipView'

export default Tooltip
